<div class="container">
  <div class="row">
    <div class="col text-center">
      <h1>Выбери свой класс</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-2" *ngFor="let classInstance of classes">
      <a [routerLink]="[classInstance.id]"><h2>{{ classInstance.title }}</h2></a>
    </div>
  </div>
</div>
